import { render } from "./OnboardingPlan.vue?vue&type=template&id=35487b14"
import script from "./OnboardingPlan.vue?vue&type=script&lang=js"
export * from "./OnboardingPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__